import { Geometry, Point } from "../../drawing";
import { AbstractValuedItem } from "./AbstractValuedItem";
import { IDrawableItem } from "./IDrawableItem";
import { PrintBehavior } from "./PrintBehavior";

export abstract class AbstractDrawableValuedItem extends AbstractValuedItem implements IDrawableItem {
  constructor(typeKey: string, value: any) {
    super(typeKey, value);
  }

  public geometry: Geometry = new Geometry();
  public isVisible: boolean = true;
  public printBehavior: PrintBehavior = new PrintBehavior();
  public isRelayoutableByHeight: boolean = false;
  public isPositionFixed: boolean = false;

  protected applyMembers(clone: AbstractDrawableValuedItem): void {
    super.applyMembers(clone);
    clone.geometry = this.cloneValue(this.geometry);
    clone.isVisible = this.cloneValue(this.isVisible);
    clone.printBehavior = this.cloneValue(this.printBehavior);
    clone.isRelayoutableByHeight = this.cloneValue(this.isRelayoutableByHeight);
    clone.isPositionFixed = this.cloneValue(this.isPositionFixed);
  }

  move(difference: Point): void {
    if (this.isPositionFixed) { return; }
    this.geometry.rectangle = this.geometry.rectangle.move(difference);
  }

  adjustObjectHeight(): void {
    // 空実装で実装しておく.必要なItemでoverrideする事.
  }
}
